exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2KGO4{position:relative;padding:10px;background-color:#fff}._2R1Qt{margin:20px 0;padding:20px 0;background:#fff;text-align:center}._1sAPP{border:2px solid #f5f5f5!important}.W6aLM{margin-top:5px!important}", ""]);

// exports
exports.locals = {
	"root": "_2KGO4",
	"defaultText": "_2R1Qt",
	"subInfoBlock": "_1sAPP",
	"subMargin": "W6aLM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/search/components/CarsList/CarsList.css
// module id = 2875
// module chunks = 20